module.exports = {
  theme: {
    mainsubcategorysbackground: "#FFFFFF",
    btnmainbackground: "#4062F6",
    btnmaintext: "#FFFFFF",
    btnsecondbackground: "#d6ddff",
    btnsecondtext: "#627EF8",
    btnthirdbackground: "#E3E8FE",
    btnthirdtext: "#627EF8",
    btnthirdicon: "#95A8FA",
    btnoutlineborder: "#E3E8FE",
    btnoutlinebackground: "#FFFFFF",
    btnoutlinetext: "#627EF8",
    btnoutlineicon: "#627EF8",
    btnoutlineactiveborder: "#627EF8",
    btnoutlineactivebackground: "#E3E8FE",
    btnoutlineactivetext: "#627EF8",
    btnoutlineactiveicon: "#627EF8",
    btndestructivebackground: "#FEE3E3",
    btndestructivetext: "#F86262",
    btndestructiveicon: "#FBA2A2",
    bordermain: "#ECECEC",
    borderonbackground: "#CFD7F7",
    backgroundmain: "#4062f6",
    backgroundmodal: "#00000030",
    backgroundmodallayover: "#00000030",
    listsborder: "",
    listsbackground: "#FFFFFF",
    liststext: "#898989",
    listscheckbackground: "#CFD7F7",
    listscheckborder: "#CFD7F7",
    listscheckicon: "#192040",
    listactiveprice: "#95A8FA",
    listactivepricetext: "#FFF",
    listsactivebackground: "#CFD7F7",
    listsactivetext: "#627EF8",
    listsactivecheckbackground: "#192040",
    listsactivecheckborder: "#192040",
    listsactivecheckicon: "#CFD7F7",

    text: "#4062f6",
    titlemain: "#707070",
    titlesecondary: "#CFD7F7",
    titlethird: "#CFD7F7",
    processtekst: "#000000",
    paymentloadingbackground: "#e2e8f0",
    buttonimgcolors: "#4062F6",
    selectitemcolor: "#4062F6",
    itembackground: "#efefef",

    iconkioskhomepagecolor: "#4062f6", // icons (house, car, left corner of the app)
    textkioskhomepagecolor: "#4062f6", // tekst on the kiosk homepage screen inside the options
    paymentfloatbackground: "#dbdbdb", // background color of the add to cart button (bottom)
    listactiveborderprice: "#5490f8",
    kioskcategorytitle: "#000", // category title
    kioskitemoverviewborder: "#000", // border inside the cart overview
    kioskpricecolor: "#000", // total price for 1 item with additions inside the cart overview
    totalpricecolor: "#000", // total price of all products in the cart overview
    totalpricetext: "#000", // color of the text 'total' inside the cart overview
    orderdetailsuccesfullpayment: "#000", // color of succesfull payment in the orderdetails page
    orderdetailordernumber: "#FFF", // color of the text inside the orderdetailscreen
    orderdetailorderbackground: "#000", // background color of the orderdetails in the orderdetail page
    gobackbutton: "#dbdbdb", // go back button background color inside the cart process
    gobackbuttontext: "#000", // go back button text color inside the cart process
    upsellingitemcolor: "#5490f8",
    additionaddbackground: "#FFF", // addition add button background color
    kioskadditiontitlecolor: "#000", // addition title color
    kiosktotalprice: "#000", // color of the total price (bottom)
    kiosktotalcolor: "#9c9c9c", // color of the total text (bottom)
    deleteiconkioskbackground: "#5490f8",
    kioskstartbackgroundbutton: "#e3e8fe", // background on the kiosk homepage screen inside the options
    kioskcancelbuttoncolor: "#000", // cancel order button text color (bottom)
    kioskcancelbuttonbackground: "#9c9c9c", // cancel order button background color (bottom)
    itemdescription: "#000", // item description inside addition modal
    kioskbordercolor: "#4062f6", // kiosk navigation border
    kioskcurrentcatborder: "#4062f6",
    kioskmodifieritemborder: "#4062f6",
    kiosknaviconcolor: "#4062f6", // arrow color from next-prev buttons in carrousel
    kiosknavactivebarcolor: "#4062f6", // color of the bar under the active category
    addmoreitemsiconbackground: "#000000", // background of + / - buttons inside additions
    kioskplusminbuttons: "#FFF", // + and - arrows inside the additions
    addmoreitemsicon: "#FFFFFF",
    addmoreitemsnumber: "#000000",
    kioskkeyboardbackgroundcolor: "#000",
    kioskkeyboardtextcolor: "#FFF",
    thanksyouimgcolor: "#627EF8", // color of the thank you image in the orderdetails page
    remainingtimebuttonbackground: "#000", // background color of the remaining time button in the orderdetals page
    remainingtimebuttontext: "#FFF", //  color of the remaining time button in the orderdetals page
    kioskbackgroundmainscreen: "#FFF", // background color for the main screen on kiosk
    kioskmaintext: "#4062f6",
    kioskdetailbackground: "#e3e8fe", // background color next-prev button in navigation and the + button from the items
    kioskarrow: "#000000",
    kioskarrowbackground: "#e2e8f0",
    kioskborder: "border-black",
    kioskdetailtext: "#4062f6", // + sign to add modifier color on the order page
    kiosklastitembackgroundcolor: "#FFFFFF",
    kiosklastitemtitle: "#000000",
    kiosklastitemprice: "#000000",

    cardmainbackground: "#E3E8FE",
    cardsecondarybackground: "#4062F6",
    paymentbtnbackground: "#4062F6",
    paymentbtntext: "#FFFFFF",
    paymentfloatactivebackground: "#FFFFFF",
    tipsfloatbackground: "#E3E8FE",
    tabsbackground: "#E3E8FE",
    tabstext: "#627EF8",
    tabsactivebackground: "#4062F6",
    tabsactivetext: "#FFFFFF",
    tabsicon: "#4062F6",
    summbackground: "#E3E8FE",
    summchildrenbackground: "#F8FAFF",
    stepsbackground: "#E3E8FE",
    stepstext: "#95A8FA",
    stepsnumber: "#95A8FA",
    stepsline: "#E3E8FE",
    stepsactivebackground: "#95A8FA",
    stepsactivetext: "#4062F6",
    stepsactivenumber: "#fff",
    timeslotactivecolor: "#404040",
    orderdetailordercolor: "#000",

    /** Diffrent in kisok and QR */
    // orderdetailorderbackground: "#dee3ff",
    // orderdetailordernumber: "#000",

    // Discount
    discountbtnbackgroundcolor: "#F68484",
    discountlistbackgroundcolor: "#fdeded",
    discountwarningcolor: "#F68484",
    discountwarningaccentcolor: "#F68484",
    discountlistitemvaluecolor: "#c04d2e",
    discountlistitemdeletebuttonbackgroundcolor: "#fee3e3",
    discountlistitemdeletebuttoniconcolor: "#fba2a2",
    discountappliedtotalcolor: "#f68484",
  },
};
